module.exports = __webpack_public_path__ + "img/bob.c43843f6.png";